export default function CardLabel({ text }) {
  return <h2 className="font-medium text-base uppercase max-w-sm">{text}</h2>;
}
